import { APP_MODULE } from '@mgCommon/constants';
import type { AppModule } from '@mgCommon/types';
import { Suspense } from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import AppSpinner from './AppSpinner';

export type ModuleLayoutProps = {
  currentModule: AppModule | undefined;
  children?: React.ReactNode;
};

export default function ModuleLayout(props: Readonly<ModuleLayoutProps>) {
  const { currentModule, children } = props;

  if (!currentModule) return null;

  return (
    <>
      <Row>
        <Col>
          <div data-testid="app-module-title" className="h3 mb-3">
            {APP_MODULE[currentModule]}
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <Suspense fallback={<AppSpinner animation="grow" />}>{children}</Suspense>
        </Col>
      </Row>
    </>
  );
}
